import React, { useState, useEffect } from 'react';
import { Table, Spinner, Alert, Card, Row, Col, Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import { useEntidadeContext } from '../../EntidadeContext';

const RelatorioPacotesTab = ({ isActive }) => {
    const { currentEntidade } = useEntidadeContext();
    const [dadosRelatorio, setDadosRelatorio] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    // Novos estados para o filtro de paciente
    const [pacientesOptions, setPacientesOptions] = useState([]);
    const [selectedPaciente, setSelectedPaciente] = useState(null);
    const [isLoadingPacientes, setIsLoadingPacientes] = useState(false);

    // Efeito para buscar a lista de pacientes para o filtro
    useEffect(() => {
        const fetchPacientes = async () => {
            if (!isActive || !currentEntidade || pacientesOptions.length > 0) return;

            setIsLoadingPacientes(true);
            try {
                const response = await axios.get(`/api/entidades/${currentEntidade.id}/pacientes/basic-info`);
                const options = (response.data.pacientes || []).map(p => ({
                    value: p.id,
                    label: `${p.nome} (${p.cpf || 'Sem CPF'})`
                }));
                setPacientesOptions(options);
            } catch (err) {
                console.error("Erro ao buscar pacientes para filtro:", err);
            } finally {
                setIsLoadingPacientes(false);
            }
        };

        fetchPacientes();
    }, [isActive, currentEntidade, pacientesOptions.length]);


    useEffect(() => {
        const fetchRelatorio = async () => {
            // A busca só acontece se a aba estiver ativa e a entidade carregada.
            if (!isActive || !currentEntidade) {
                return;
            }
            setIsLoading(true);
            setError(null);
            try {
                const params = { entidade_id: currentEntidade.id };
                if (selectedPaciente) {
                    params.paciente_id = selectedPaciente.value;
                }

                const response = await axios.get(`/api/relatorios/pacotes/sessoes-restantes`, {
                    params: params
                });

                const dadosOrdenados = (response.data.dados || []).sort((a, b) => {
                    const nomeA = a.paciente_nome || '';
                    const nomeB = b.paciente_nome || '';
                    return nomeA.localeCompare(nomeB);
                });
                setDadosRelatorio(dadosOrdenados);
            } catch (err) {
                console.error("Erro ao buscar relatório de pacotes:", err);
                setError("Não foi possível carregar o relatório. Tente novamente mais tarde.");
                setDadosRelatorio([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchRelatorio();
    }, [isActive, currentEntidade, selectedPaciente]); // Adiciona selectedPaciente como dependência

    if (isLoading) {
        return (
            <div className="text-center mt-3">
                <Spinner animation="border" />
                <p>Carregando relatório...</p>
            </div>
        );
    }

    if (error) {
        return <Alert variant="danger" className="mt-3">{error}</Alert>;
    }

    return (
        <Card className="mt-3">
            <Card.Header>
                <Card.Title>Pacotes com Sessões Restantes</Card.Title>
            </Card.Header>
            <Card.Body>
                <Form className="mb-4">
                    <Row className="align-items-end">
                        <Col md={6}>
                            <Form.Group controlId="filtroPaciente">
                                <Form.Label>Filtrar por Paciente (Opcional)</Form.Label>
                                <Select
                                    options={pacientesOptions}
                                    value={selectedPaciente}
                                    onChange={setSelectedPaciente}
                                    isClearable
                                    isLoading={isLoadingPacientes}
                                    placeholder="Digite para buscar um paciente..."
                                    noOptionsMessage={() => 'Nenhum paciente encontrado'}
                                />
                            </Form.Group>
                        </Col>
                        {/* O filtro é aplicado automaticamente ao selecionar, mas um botão de limpar é útil */}
                        <Col md={6} className="text-start text-md-start mt-2 mt-md-0">
                            <Button variant="outline-secondary" onClick={() => setSelectedPaciente(null)} disabled={!selectedPaciente}>Limpar Filtro</Button>
                        </Col>
                    </Row>
                </Form>

                {dadosRelatorio.length > 0 ? (
                    <Table striped bordered hover responsive="sm">
                        <thead>
                            <tr>
                                <th>Paciente</th>
                                <th>Serviço (Pacote)</th>
                                <th className="text-center">Sessões Restantes</th>
                                <th>Data da Compra</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dadosRelatorio.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.paciente_nome}</td>
                                    <td>{item.servico_nome}</td>
                                    <td className="text-center">{item.sessoes_restantes}</td>
                                    <td>{item.data_compra}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <Alert variant="info">Nenhum pacote com sessões restantes encontrado para os filtros aplicados.</Alert>
                )}
            </Card.Body>
        </Card>
    );
};

export default RelatorioPacotesTab;